// 区域code
const areaTypeMap = {
	cn: 'cn', // 大陆
	hmt: 'hmt', // 港澳台
	ibu: 'ibu' // 国际
}
// 区域选择器tab
const areaTabMap = [
	{
		name: '中国大陆',
		code: areaTypeMap.cn
	},
	{
		name: '中国港澳台',
		code: areaTypeMap.hmt
	},
	{
		name: '国际',
		code: areaTypeMap.ibu
	}
]
// 区域选择器标签tab
const LabelTabText = new Map([
	[areaTypeMap.cn, ['省份', '城市', '区县']],
	[areaTypeMap.hmt, ['区域', '城市', '区县']],
	[areaTypeMap.ibu, ['国家']]
])
// 行政区的regionKey
const regionKey = new Map([
	[areaTypeMap.cn, 'local_region_cn_sc'],
	[areaTypeMap.hmt, 'local_region_hk_mo_tw_sc'],
	[areaTypeMap.ibu, 'local_ibu_hotcounties_sc']
])
export {
	areaTypeMap, areaTabMap, LabelTabText, regionKey
}



// WEBPACK FOOTER //
// ./src/components/areaSelector/config.js